const data = [
    {
      id: 1,
      img: "https://m.media-amazon.com/images/I/6125yAfsJKL._AC_UX575_.jpg",
      title: "Nike Air Monarch IV",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "white",
      category: "sneakers",
      qty:1,
    },
    {
      id: 2,
      img: "https://m.media-amazon.com/images/I/519MRhRKGFL._AC_UX575_.jpg",
      title: "Nike Air Vapormax Plus",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "red",
      category: "sneakers",
      qty:1,
    },
  
    {
      id: 3,
      img: "https://m.media-amazon.com/images/I/51+P9uAvb1L._AC_UY695_.jpg",
      title: "Nike Waffle One Sneaker",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "green",
      category: "sneakers",
      qty:1,
    },
    {
      id: 4,
      img: "https://m.media-amazon.com/images/I/71oEKkghg-L._AC_UX575_.jpg",
      title: "Nike Running Shoe",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Adidas",
      color: "black",
      category: "sneakers",
      qty: 1,
    },
    {
      id: 5,
      img: "https://m.media-amazon.com/images/I/41M54ztS6IL._AC_SY625._SX._UX._SY._UY_.jpg",
      title: "Flat Slip On Pumps",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Vans",
      color: "green",
      category: "flats",
      qty: 1,
    },
    {
      id: 6,
      img: "https://m.media-amazon.com/images/I/71zKuNICJAL._AC_UX625_.jpg",
      title: "Knit Ballet Flat",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Adidas",
      color: "black",
      category: "flats",
      qty: 1,
    },
  
    {
      id: 7,
      img: "https://m.media-amazon.com/images/I/61V9APfz97L._AC_UY695_.jpg",
      title: "Loafer Flats",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Vans",
      color: "white",
      category: "flats",
      qty: 1,
    },
  
    {
      id: 8,
      img: "https://m.media-amazon.com/images/I/71VaQ+V6XnL._AC_UY695_.jpg",
      title: "Nike Zoom Freak",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "green",
      category: "sneakers",
      qty:1,
    },
  
    {
      id: 9,
      img: "https://m.media-amazon.com/images/I/61-cBsLhJHL._AC_UY695_.jpg",
      title: "Nike Men's Sneaker",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Adidas",
      color: "blue",
      category: "sneakers",
      qty: 1,
    },
  
    {
      id: 10,
      img: "https://m.media-amazon.com/images/I/81xXDjojYKS._AC_UX575_.jpg",
      title: "PUMA BLACK-OCE",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Puma",
      color: "green",
      category: "sneakers",
      qty: 1
    },
    {
      id: 11,
      img: "https://m.media-amazon.com/images/I/71E75yRwCDL._AC_UY575_.jpg",
      title: "Pacer Future Sneaker",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Puma",
      color: "red",
      category: "sneakers",
      qty: 1
    },
    {
      id: 12,
      img: "https://m.media-amazon.com/images/I/71jeoX0rMBL._AC_UX575_.jpg",
      title: "Unisex-Adult Super",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Puma",
      color: "black",
      category: "sneakers",
      qty: 1
    },
    {
      id: 13,
      img: "https://m.media-amazon.com/images/I/61TM6Q9dvxL._AC_UX575_.jpg",
      title: "Roma Basic Sneaker",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Puma",
      color: "white",
      category: "sneakers",
      qty: 1
    },
    {
      id: 14,
      img: "https://m.media-amazon.com/images/I/7128-af7joL._AC_UY575_.jpg",
      title: "Pacer Future Doubleknit",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Puma",
      color: "black",
      category: "sneakers",
      qty: 1
    },
  
    {
      id: 15,
      img: "https://m.media-amazon.com/images/I/81xXDjojYKS._AC_UX575_.jpg",
      title: "Fusion Evo Golf Shoe",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 100,
      company: "Puma",
      color: "green",
      category: "sneakers",
      qty: 1
    },
    {
      id: 16,
      img: "https://m.media-amazon.com/images/I/719gdz8lsTS._AC_UX575_.jpg",
      title: "Rainbow Chex Skate",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 100,
      company: "Vans",
      color: "red",
      category: "flats",
      qty: 1,
    },
    {
      id: 17,
      img: "https://m.media-amazon.com/images/I/71gpFHJlnoL._AC_UX575_.jpg",
      title: "Low-Top Trainers",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 100,
      company: "Vans",
      color: "white",
      category: "sandals",
      qty: 1,
    },
    {
      id: 18,
      img: "https://m.media-amazon.com/images/I/71pf7VFs9CL._AC_UX575_.jpg",
      title: "Vans Unisex Low-Top",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 100,
      company: "Vans",
      color: "blue",
      category: "sandals",
      qty: 1,
    },
    {
      id: 19,
      img: "https://m.media-amazon.com/images/I/61N4GyWcHPL._AC_UY575_.jpg",
      title: "classNameic Bandana Sneakers",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Nike",
      color: "black",
      category: "sandals",
      qty:1,
    },
    {
      id: 20,
      img: "https://m.media-amazon.com/images/I/61bncQ44yML._AC_UX695_.jpg",
      title: "Chunky High Heel",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Vans",
      color: "black",
      category: "heels",
      qty: 1,
    },
    {
      id: 21,
      img: "https://m.media-amazon.com/images/I/71czu7WgGuL._AC_UY695_.jpg",
      title: "Slip On Stiletto High Heel",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 100,
      company: "puma",
      color: "black",
      category: "heels",
      qty: 1
    },
    {
      id: 22,
      img: "https://m.media-amazon.com/images/I/61men05KRxL._AC_UY625_.jpg",
      title: "DREAM PAIRS Court Shoes",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Nike",
      color: "red",
      category: "heels",
      qty:1,
    },
    {
      id: 23,
      img: "https://m.media-amazon.com/images/I/519MRhRKGFL._AC_UX575_.jpg",
      title: "Nike Air Vapormax Plus",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "red",
      category: "sneakers",
      qty:1,
    },
  
    {
      id: 24,
      img: "https://m.media-amazon.com/images/I/51PGWTXgf-L._AC_UY625_.jpg",
      title: "Low Mid Block Heels",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 200,
      company: "Nike",
      color: "black",
      category: "heels",
      qty:1,
    },
    {
      id: 25,
      img: "https://m.media-amazon.com/images/I/616sA5XUKtL._AC_UY675_.jpg",
      title: "Chunky High Heel",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Adidas",
      color: "black",
      category: "heels",
      qty: 1,
    },
    {
      id: 26,
      img: "https://m.media-amazon.com/images/I/71h5+MbEK7L._AC_UY625_.jpg",
      title: "Amore Fashion Stilettos",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 150,
      company: "Adidas",
      color: "white",
      category: "heels",
      qty: 1,
    },
    {
      id: 27,
      img: "https://m.media-amazon.com/images/I/61uw5RDxKQL._AC_UY625_.jpg",
      title: "Bridal Sandals Glitter",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Adidas",
      color: "black",
      category: "heels",
      qty: 1,
    },
    {
      id: 28,
      img: "https://m.media-amazon.com/images/I/71yhoZP0l6L._AC_UY695_.jpg",
      title: "Wedding Prom Bridal",
      star: <i className="ri-star-fill"></i>,
      reviews: "(123 reviews)",
      prevPrice: "$140,00",
      newPrice: 50,
      company: "Adidas",
      color: "black",
      category: "flats",
      qty: 1,
    },
  ];

export default data